import { render, staticRenderFns } from "./Block2Vue.vue?vue&type=template&id=4ed95bc6&scoped=true"
import script from "./Block2Vue.vue?vue&type=script&lang=js"
export * from "./Block2Vue.vue?vue&type=script&lang=js"
import style0 from "./Block2Vue.vue?vue&type=style&index=0&id=4ed95bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed95bc6",
  null
  
)

export default component.exports